import { render, staticRenderFns } from "./OrbitLeaderboardCards.vue?vue&type=template&id=615a4731&scoped=true"
import script from "./OrbitLeaderboardCards.vue?vue&type=script&lang=ts"
export * from "./OrbitLeaderboardCards.vue?vue&type=script&lang=ts"
import style0 from "./OrbitLeaderboardCards.vue?vue&type=style&index=0&id=615a4731&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615a4731",
  null
  
)

export default component.exports